import Dexie, { type EntityTable } from 'dexie';

export interface PendingUpdate {
  id: number;
  update: Uint8Array;
}

export class LocalPendingUpdateDb {
  private db: Dexie & {
    pendingUpdates: EntityTable<
      PendingUpdate,
      'id' // primary key "id" (for the typings only)
    >;
  };

  constructor(userName: string) {
    this.db = new Dexie(`${userName}/PendingUpdates`) as Dexie & {
      pendingUpdates: EntityTable<
        PendingUpdate,
        'id' // primary key "id" (for the typings only)
      >;
    };

    // Schema declaration:
    this.db.version(1).stores({
      pendingUpdates: '++id, update' // primary key "id" (for the runtime!)
    });
  }

  destroy = async (): Promise<void> => {
    this.db.close();
  }

  addPendingUpdate = async (update: Uint8Array): Promise<number> => {
    return await this.db.pendingUpdates.add({ update });
  }

  getPendingUpdates = async (): Promise<PendingUpdate[]> => {
    const pendingUpdates = await this.db.pendingUpdates.toArray();
    return pendingUpdates;
  }

  deletePendingUpdates = async (id: number[]): Promise<void> => {
    await this.db.pendingUpdates.bulkDelete(id);
  }

  onNewPendingUpdate = (
    callback: (_: number, pendingUpdate: PendingUpdate) => void
  ): void => {
    this.db.pendingUpdates.hook('creating', callback);
  }

  offNewPendingUpdate = (
    callback: (_: number, pendingUpdate: PendingUpdate) => void
  ): void => {
    this.db.pendingUpdates.hook('creating').unsubscribe(callback);
  }
}
